import { render, staticRenderFns } from "./jg_visualization_collectionStatistics.vue?vue&type=template&id=21122de6"
import script from "./jg_visualization_collectionStatistics.vue?vue&type=script&lang=js"
export * from "./jg_visualization_collectionStatistics.vue?vue&type=script&lang=js"
import style0 from "./jg_visualization_collectionStatistics.vue?vue&type=style&index=0&id=21122de6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports